module.exports = __webpack_public_path__ + "static/media/tomHi.2d62a95f.wav";